export default function MySQL_GROUPBY() {
  return (
    <div>
      <h2>MySQL_GROUPBY</h2>    </div>
  );
}